const { connect } = require('react-redux');
const stageStartComponent = require('../component/stageStartComponent').default;
const { actions } = require('../../../../reducers').default;
const { modalType } = require('../../../../define/screenType').default;
// ======================

const mapStateToProps = (state) => {
    const { screenState, playerState, gameState, appState } = state;
    return {
        isModalOpen: screenState.modal === modalType.MODAL_STAGE_START,
        soundEnable: appState.soundEnable,
        playerState,
        gameState
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleStartClick: () => {
            dispatch(actions.gameResume());
        }
    };
};

export const StageStartContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(stageStartComponent);